export default "/_next/static/images/Falcon_wordmark_black-f63c7a56cf74a9cd9a10f0382e3eddcd.svg";